"use client";

import { useFormContext, useWatch } from "react-hook-form";

import { isIneligible } from "./eligibility-gate";
import type { EligibilityGate } from "./eligibility-gate";

/**
 * Informational note shown when the watched field holds an ineligible value.
 *
 * The container is always rendered (and is a polite live region) so the text
 * is announced when it appears. Subscribes to the form on its own, so a
 * change re-renders only this note, never the other fields. Styling is left to
 * the consumer via `[data-eligibility-note]`.
 */
export function EligibilityNote({ gate }: { gate: EligibilityGate }) {
  const { control } = useFormContext();
  const value: unknown = useWatch({ control, name: gate.watch });

  return (
    <div data-eligibility-note aria-live="polite" className="col-span-full">
      {isIneligible(gate, value) ? <p>{gate.message}</p> : null}
    </div>
  );
}
